(() => {
    const triggers = Array.from(document.querySelectorAll('[data-menu-trigger]'));
    const panels = Array.from(document.querySelectorAll('[data-menu-panel]'));

    if (triggers.length === 0 || panels.length === 0) return;

    const getPanelByName = (name) => panels.find((p) => p.dataset.menuPanel === name) || null;

    const closeAll = () => {
        panels.forEach((panel) => {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
        });

        triggers.forEach((btn) => {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('is-active'); // ← “×”を戻す
        });

        document.body.classList.remove('is-menuOpen');
    };

    const openOne = (name, openerBtn) => {
        closeAll();

        const panel = getPanelByName(name);
        if (!panel) return;

        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');

        openerBtn.setAttribute('aria-expanded', 'true');
        openerBtn.classList.add('is-active'); // ← “×”にする

        document.body.classList.add('is-menuOpen');

        const content = panel.querySelector('[data-menu-content]');
        if (content) content.focus({
            preventScroll: true
        });
    };

    const isOpen = (name) => {
        const panel = getPanelByName(name);
        return !!panel && panel.classList.contains('is-open');
    };

    triggers.forEach((btn) => {
        btn.addEventListener('click', () => {
            const name = btn.dataset.menuTrigger;
            if (!name) return;

            if (isOpen(name)) {
                closeAll();
                btn.focus({
                    preventScroll: true
                });
                return;
            }

            openOne(name, btn);
        });
    });

    panels.forEach((panel) => {
        const backdrop = panel.querySelector('[data-menu-backdrop]');
        if (!backdrop) return;

        backdrop.addEventListener('click', () => {
            closeAll();
        });
    });

    window.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        const anyOpen = panels.some((p) => p.classList.contains('is-open'));
        if (!anyOpen) return;

        e.preventDefault();
        closeAll();
    });
})();